import WordHighlighter from 'vue-word-highlighter';
export default {
  props: {
    // 显示的文本
    text: {
      type: String,
      default: ''
    },
    // 最多展示的行数
    maxLines: {
      type: Number,
      default: 1
    },
    // 组件宽
    width: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: 'tooltip'
    },
    // el-tooltip Attributes
    tooltipAttrs: {
      type: Object,
      default: function _default() {
        return {
          effect: 'dark',
          placement: 'top'
        };
      }
    },
    fontSize: {
      type: Number,
      default: 14
    },
    query: {
      type: String,
      default: ''
    }
  },
  components: {
    WordHighlighter: WordHighlighter
  },
  data: function data() {
    return {
      offset: this.text.length,
      // 原始文本length
      expanded: false,
      // 是否已展开
      slotBoxWidth: 0,
      // 展开收起按钮宽度
      textBoxWidth: this.width,
      // 展示的文本宽度
      showSlotNode: false,
      // 是否展示slot节点
      tootip: false
    };
  },
  watch: {
    text: function text(newVal, oldVal) {
      this.showTips(newVal);
    }
  },
  computed: {
    // 设置展示文本宽度
    boxStyle: function boxStyle() {
      if (this.width) {
        return {
          width: this.width + 'px'
        };
      } else {
        return {
          width: 'auto'
        };
      }
    },
    // 是否被截取
    isCutOut: function isCutOut() {
      var isCutOut = this.offset !== this.text.length;
      return isCutOut && !this.expanded;
    },
    // 获取展示文本
    realText: function realText() {
      var realText = this.text;
      if (this.isCutOut) {
        realText = this.text.slice(0, this.offset) + '...';
      }
      return realText;
    }
  },
  mounted: function mounted() {
    this.showTips(this.text);
    // const { len } = this.getLines();
    // if ( len > this.maxLines ) {
    // this.showSlotNode = true;
    // this.$nextTick(() => {
    // this.slotBoxWidth = this.$refs.slotRef.clientWidth;
    // his.textBoxWidth = this.$refs.textOverflow.clientWidth;
    // this.calculateOffset( 0, this.text.length );
    // });
    // }
  },
  methods: {
    // 计算offset 核心代码
    calculateOffset: function calculateOffset(from, to) {
      var _this = this;
      this.$nextTick(function () {
        if (Math.abs(from - to) <= 1) {
          return;
        }
        if (_this.isOverflow()) {
          // eslint-disable-next-line no-param-reassign
          to = _this.offset;
        } else {
          // eslint-disable-next-line no-param-reassign
          from = _this.offset;
        }
        _this.offset = Math.floor((from + to) / 2);
        _this.calculateOffset(from, to);
      });
    },
    // 内容是否溢出
    isOverflow: function isOverflow() {
      var _this$getLines = this.getLines(),
        len = _this$getLines.len,
        lastWidth = _this$getLines.lastWidth;
      if (len < this.maxLines) {
        return false;
      }
      if (this.maxLines) {
        // 超出部分 行数 > 最大行数 或者  已经是最大行数但最后一行宽度 + 后面内容超出正常宽度
        var lastLineOver = Boolean(len === this.maxLines && lastWidth + this.slotBoxWidth > this.textBoxWidth);
        if (len > this.maxLines || lastLineOver) {
          return true;
        }
      }
      return false;
    },
    // 获取元素占据页面的所有矩形区域的行数和最后一行宽度
    getLines: function getLines() {
      // getClientRects()：是获取元素占据页面的所有矩形区域：
      var clientRects = this.$refs.overEllipsis.getClientRects();
      return {
        len: clientRects.length,
        lastWidth: clientRects[clientRects.length - 1].width
      };
    },
    // 切换展开收起
    toggle: function toggle() {
      this.expanded = !this.expanded;
    },
    showTips: function showTips(content) {
      var temporaryTag = document.createElement('span');
      temporaryTag.style.fontSize = this.fontSize;
      temporaryTag.innerHTML = content;
      temporaryTag.id = 'getTextWidth';
      document.querySelector('body').appendChild(temporaryTag);
      var currentWidth = document.querySelector('#getTextWidth').offsetWidth;
      document.querySelector('#getTextWidth').remove();
      this.tootip = currentWidth < this.maxLines * this.width;
    }
  }
};